import { PaginationType } from "@/types"
import Cookies from "js-cookie"

import { CommodityRate } from "@/types/meter"

import { apiFetch } from "../utils"
import { postActivityLog } from "./log"

const billingUrl = `himo-billing/`

export async function getCommodityRates(): Promise<
  PaginationType<CommodityRate>
> {
  const response = await apiFetch(`himo-billing/commodity-rates/?page=1&size=100`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Error fetching ${response.statusText}`)
  }

  return await response.json()
}

//This endpoint used to create new connection status
export async function addCommodityRate(data: CommodityRate) {

  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(`${billingUrl}commodity-rates/create/`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    if (!response.ok) {
      await postActivityLog({
        menu_path:
          "HIMO Billing-Digos Water District-Meter & Connection Settings",
        sub_menu_path: "/meter-connection-settings/commodity-rates",
        action: "Add Commodity Rate",
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })

      throw new Error(`Error: ${response.statusText}`)
    }

    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/commodity-rates",
      action: "Add Commodity Rate",
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    return response.json()
  }

  return null
}

//Used to Edit/Update Commodity Rate
export async function editCommodityRate(
  commodityRateId: number,
  data: CommodityRate,
) {
  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(
      `${billingUrl}commodity-rates/update/${commodityRateId}/`,
      {
        method: "PUT",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    )
    if (!response.ok) {
      await postActivityLog({
        menu_path:
          "HIMO Billing-Digos Water District-Meter & Connection Settings",
        sub_menu_path: "/meter-connection-settings/commodity-rates",
        action: "Update Commodity Rate",
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })

      throw new Error(`Error: ${response.statusText}`)
    }

    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/commodity-rates",
      action: "Update Commodity Rate",
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    return response.json()
  }

  return null
}
//this endpoint use to delete/remove commodity rate
export async function deleteCommodityRate(id: number) {
  const response = await apiFetch(`${billingUrl}commodity-rates/delete/${id}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/commodity-rates",
      action: `Delete Commodity Rate (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/commodity-rates",
    action: `Delete Commodity Rate (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  if (response.status === 204) {
    return null
  }

  const contentType = response.headers.get("content-type")
  if (contentType && contentType.includes("application/json")) {
    return response.json()
  } else {
    return null
  }
}
